import { Box, Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';

import ScorePropTypes from '../../proptypes/score';
import {
    computeDisplayableCo2g,
    computeDisplayableCo2gPerMin,
    computeDisplayableCo2gWithUnit,
} from '../../services/computation/computeDisplayableCo2g';
import {
    computeDisplayableMilliWhPerMin,
    computeDisplayableMilliWithUnit,
    computeMilliWh,
} from '../../services/computation/computeMilliWh';
import CustomSwitch from './CustomSwitch';

const ArrayScoreConsumption = ({ executionCount, score }) => {
    const [displayCo2, setDisplayCo2] = useState(true);
    return (
        <Box
            display="flex"
            alignContent="center"
            flexWrap="wrap"
            width="fit-content"
            borderRadius={1}
            textAlign="left"
            minHeight={100}
            paddingY={2}
            sx={{ '& hr': { mx: 5 } }}
        >
            <Box>
                <Typography variant="body1">Per minute</Typography>
                <Typography variant="h5">
                    {displayCo2
                        ? `${computeDisplayableCo2gPerMin(score)} mg/min`
                        : `${computeDisplayableMilliWhPerMin(score)} mWh/min`}
                </Typography>
            </Box>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Box>
                <Typography variant="body1">Per execution</Typography>
                <Typography variant="h5">
                    {displayCo2
                        ? `${computeDisplayableCo2g(score?.co2?.total)} mg`
                        : `${computeMilliWh(score?.wh?.total)} mWh`}
                </Typography>
            </Box>
            <Divider orientation="vertical" variant="middle" flexItem />
            {executionCount && (
                <>
                    <Box>
                        <Typography variant="body1">
                            {executionCount} executions
                        </Typography>
                        <Typography variant="h5">
                            {displayCo2
                                ? computeDisplayableCo2gWithUnit(
                                      score?.co2?.total,
                                      executionCount
                                  )
                                : computeDisplayableMilliWithUnit(
                                      score?.wh?.total,
                                      executionCount
                                  )}
                        </Typography>
                    </Box>
                    <Divider orientation="vertical" variant="middle" flexItem />
                </>
            )}

            <Box>
                <Typography variant="body1">Unit</Typography>
                <Box display="flex" gap={1} alignItems="center">
                    <Typography color="grey.500">Co2 eq.</Typography>
                    <CustomSwitch onChange={() => setDisplayCo2(!displayCo2)} />
                    <Typography color="grey.500">Energy</Typography>
                </Box>
            </Box>
        </Box>
    );
};

ArrayScoreConsumption.propTypes = {
    score: ScorePropTypes.isRequired,
    executionCount: PropTypes.number,
};

export default ArrayScoreConsumption;
